import {Component, input} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';

@Component({
  selector: 'app-no-data',
  imports: [TranslocoPipe],
  templateUrl: './no-data.component.html',
})
export class NoDataComponent {
  readonly label = input<string>('common.noDataAvailable');
  readonly icon = input<string>('');
  readonly description = input<string>('');
  readonly testId = input<string>('');
  readonly textTestId = input<string>('');
}
